import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './App';
import './index.css';
// Initialize widget when DOM is ready
function initWidget() {
    const containerId = 'virtual-banker-widget';
    let container = document.getElementById(containerId);
    if (!container) {
        container = document.createElement('div');
        container.id = containerId;
        document.body.appendChild(container);
    }
    const root = ReactDOM.createRoot(container);
    root.render(_jsx(React.StrictMode, { children: _jsx(App, {}) }));
}
// Auto-initialize if script is loaded
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initWidget);
}
else {
    initWidget();
}
// Export for manual initialization
window.VirtualBankerWidget = {
    init: initWidget,
};
